import React from "react";
import { createUseStyles } from "react-jss";
import { BackgroundImage } from "ComponentsUI/BackgroundImage";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { webpSimpleTransformer } from "Helpers/ImageManager";
import { OperatorBannerInfo } from "ComponentsUI/OperatorBanner";

const useStyles = createUseStyles((theme) => ({
	root: {
		position: "relative",
		zIndex: 0,
		backgroundColor: theme.palette.colors.slateBlue,
		minHeight: "250px",
		paddingTop: "166px",
		"&:hover": {
			"& $carouselCtrl": {
				opacity: 1,
				visibility: "hidden",
			},
		},
	},
	carouselCtrl: {},
	wrapper: {
		padding: "55px 0 75px",
	},
	wrapperHeader: {
		width: "100%",
	},
	wrapperHeaderLeft: {
		marginBottom: "60px",
	},
	searchHeader: {
		fontSize: "24px",
		fontFamily: theme.fonts.bold,
		lineHeight: 1,
		letterSpacing: "-.67px",
		color: theme.palette.colors.white,
		marginBottom: "27px",
	},
	breadcrumbs: {
		marginBottom: "20px",
	},
	wrapperLogoAndName: {
		display: "flex",
		alignItems: "center",
		marginBottom: "22px",
	},
	logo: {
		marginRight: "21px",
		"& img": {
			height: "56px",
			padding: "8px",
			borderRadius: "10px",
			boxSizing: "content-box",
			backgroundColor: "rgba(210, 206, 224, 0.6)",
		},
	},
	name: {
		fontFamily: theme.fonts.bold,
		fontSize: "24px",
		color: theme.palette.colors.white,
		margin: 0,
		lineHeight: "normal",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		wrapper: {
			padding: "56px 0 75px",
		},
		breadcrumbs: {
			marginBottom: "20px",
		},
		wrapperHeaderLeft: {
			marginBottom: "55px",
		},
		searchHeader: {
			fontSize: "21px",
			marginBottom: "33px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			paddingTop: "195px",
		},
		wrapper: {
			padding: "55px 0 65px",
		},
		breadcrumbs: {
			marginBottom: "20px",
		},
		wrapperHeaderLeft: {
			marginBottom: "40px",
		},
		logo: {
			"& img": {
				height: "46px",
			},
		},
		searchHeader: {
			fontSize: "21px",
			marginBottom: "40px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			paddingTop: "60px",
		},
		wrapper: {
			padding: "20px 0 36px",
		},
		wrapperHeaderLeft: {
			width: "100%",
			marginBottom: "30px",
		},
		wrapperLogoAndName: {
			flexDirection: "column",
			marginBottom: "27px",
		},
		breadcrumbs: {
			marginBottom: "20px",
			minHeight: "61px",
		},
		logo: {
			display: "flex",
			justifyContent: "center",
			marginBottom: "16px",
			marginRight: 0,
			"& img": {
				minHeight: "46px",
			},
		},
		searchHeader: {
			fontSize: "14px",
			marginBottom: "18px",
			textAlign: "center",
		},
	},
}));

const OperatorBanner = (props) => {
	const classes = useStyles();

	let breadcrumbs = null;

	if (props.breadCrumbs) {
		breadcrumbs = React.cloneElement(props.breadCrumbs, {
			background: !!props.background,
			white: true,
		});
	}

	return (
		<div id="operator_banner" className={classes.root}>
			{props.background && (
				<BackgroundImage
					webpTransformer={webpSimpleTransformer}
					windowSizes={props.windowSizes}
					background={props.background}
					shiftY={25}
				/>
			)}
			<Container>
				<Row>
					<Col xs={12}>
						<div className={classes.wrapper}>
							<div className={classes.wrapperHeader}>
								<div
									className={classes.wrapperHeaderLeft}
									itemScope
									itemType="http://schema.org/ImageObject"
								>
									<div className={classes.breadcrumbs}>{breadcrumbs}</div>
									<div className={classes.wrapperLogoAndName}>
										<div
											className={classes.logo}
											onClick={() => props.clickLogoHandler && props.clickLogoHandler()}
										>
											{!props.isStub && (
												<picture>
													<source
														type="image/webp"
														srcSet={webpSimpleTransformer(props.providerLogo)}
													/>
													<source srcSet={props.providerLogo} />
													<img src={props.providerLogo} itemProp="contentUrl" />
												</picture>
											)}
										</div>
										{!props.notH1 && (
											<h1 className={classes.name} itemProp="name">
												{props.h1}
											</h1>
										)}
										{props.notH1 && <div className={classes.name}>{props.h1}</div>}
									</div>
									{!!props?.data && (
										<OperatorBannerInfo
											text={props.text}
											site={props.site}
											phone={props.phone}
											nameLegal={!props.isStub ? props.data.contacts.name_legal : ""}
											phoneSupport={props.phoneSupport}
											background={!!props.background}
											link={props.data?.contacts?.link}
											cardType={props.data?.contacts?.card}
											fakePhone={!props.isStub && props.data?.vip_provider == 1}
											soldToProvider={props.data?.sell_self?.provider}
											h1After={props.h1After}
										/>
									)}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default OperatorBanner;
